import { useStoreCommon } from '../store/common';
import { useWindowResize } from '.';

/**
 * 页面基础初始化
 */
export const usePageBaseInit = (isFullScreen = false) => {
    const storeCommon = useStoreCommon();
    storeCommon.initUrlParams(); // 初始化URL参数
    storeCommon.initSystemInfo(); // 初始化系统信息
    storeCommon.dynamicWidth(isFullScreen); // 动态宽度 - 屏幕适配， 窗口大小变化时重新计算
    storeCommon.initInTopTab(); // 初始化书城顶部tab
    useWindowResize(() => {
        storeCommon.dynamicWidth(isFullScreen);
    });
};
